import { ChangeDetectionStrategy, Component, DestroyRef, ElementRef, HostListener, OnInit, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthService } from 'app/core/auth/auth.service';
import { UsuarioService } from 'app/core/services/usuario.service';
import { OrganizacaoService } from 'app/core/services/organizacao.service';
import { OabSetoresModalV2Component } from '../oab-setores-modal/oab-setores-modal.component';
import { OabAlterarSenhaModalV2Component } from '../oab-alterar-senha-modal/oab-alterar-senha-modal.component';

@Component({
    selector: 'oab-profile-dropdown-v2',
    templateUrl: './oab-profile-dropdown.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [OabSetoresModalV2Component, OabAlterarSenhaModalV2Component],
})
export class OabProfileDropdownV2Component implements OnInit {
  private authService = inject(AuthService);
  private usuarioService = inject(UsuarioService);
  private organizacaoService = inject(OrganizacaoService);
  private host = inject<ElementRef<HTMLElement>>(ElementRef);
  private destroyRef = inject(DestroyRef);

  // Controle próprio do menu (evita o Tether/Bootstrap, que soltava o menu desconectado do card).
  menuOpen = false;
  name: string;
  marcaOab: string;
  sectorName: string;
  readonly orgName = signal('');
  avatarInitial = '?';
  srcImgAvatar = '';
  showImgAvatar = false;
  isChangeSetorModalVisible = false;
  isChangePasswordModalVisible = false;

  toggleMenu(event: MouseEvent) {
    event.stopPropagation();
    this.menuOpen = !this.menuOpen;
  }

  closeMenu() {
    this.menuOpen = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (this.menuOpen && !this.host.nativeElement.contains(event.target as Node)) {
      this.closeMenu();
    }
  }

  @HostListener('document:keydown.escape')
  onEscape() {
    this.closeMenu();
  }
  ngOnInit() {
    this.sectorName = localStorage.getItem('setor-name');

    // Reaproveita os dados do usuário que antes apareciam na topbar.
    const user = this.usuarioService.getUser();
    this.name = user?.name || '';
    this.avatarInitial = (this.name || '?').trim().charAt(0).toUpperCase() || '?';

    const idenOgan = Number(this.usuarioService.getIdenOgan());
    if (idenOgan === 49) {
      this.orgName.set('Conselho Federal');
    } else if (idenOgan) {
      this.organizacaoService.getOrganization(idenOgan).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(org => {
        this.orgName.set(org?.data?.[0]?.nomeOgan || org?.data?.[0]?.siglUF || '');
      });
    }
  }

  changeSetorModalVisible() {
   this.closeMenu();
   this.isChangeSetorModalVisible = true;
  }

  hideSetorModal(event) {
   this.isChangeSetorModalVisible = false;
  }

  changePasswordModalVisible() {
    this.closeMenu();
    this.isChangePasswordModalVisible = true;
   }
 
   hidePasswordModal(event) {
    this.isChangePasswordModalVisible = false;
   }

  showMdlChangePassword() {

  }
  logout() {
   this.authService.logout();
  }
}
